import getUrlParams from './get-url-params';

const isSEO = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new window.URLSearchParams(getUrlParams());
    return urlParams?.get('gi_source') === 'google' && urlParams?.get('gi_medium') === 'organic';
  }
  return false;
};

export default isSEO;
